import { Skeleton } from '@/shared/components/ui/skeleton';

/** Route-level loading state while Cameras' first page is populated. */
export function SupervisorCamerasPendingState() {
  return (
    <div
      className="@container/supervisor flex min-h-0 min-w-0 flex-1 flex-col gap-4 overflow-hidden bg-background p-4 md:p-6"
      aria-busy="true"
    >
      <header className="flex shrink-0 flex-wrap items-center justify-between gap-x-4 gap-y-2">
        <Skeleton className="h-6 w-24" />
        <div className="flex min-w-0 flex-wrap items-center justify-end gap-2">
          <Skeleton className="h-8 w-44" />
          <Skeleton className="h-8 w-28" />
          <Skeleton className="h-8 w-36" />
          <Skeleton className="h-8 w-40" />
        </div>
      </header>
      <Skeleton className="h-4 w-full max-w-3xl" />
      <Skeleton className="h-4 w-24" />
      <div className="min-h-0 flex-1 overflow-hidden rounded-md border p-2">
        <Skeleton className="h-9 w-full" />
        <div className="space-y-2 p-2">
          <Skeleton className="h-14 w-full" />
          <Skeleton className="h-14 w-full" />
          <Skeleton className="h-14 w-full" />
          <Skeleton className="h-14 w-full" />
        </div>
      </div>
    </div>
  );
}
